import Vue from 'vue'

import {
	Button,
	Input,
	InputNumber,
	Breadcrumb,
	BreadcrumbItem,
	Radio, Checkbox,
	Rate, Pagination,
	CheckboxButton,
	Cascader,
	Message,
	Popover,
	Tooltip,
	Form,
	FormItem,
	MessageBox,
	Select,
	Option,
	Upload,
	Dialog,
	Table,
	TableColumn,
	Container,
	Header,
	Aside,
	Main,
	Submenu,
	Menu,
	MenuItem,
	MenuItemGroup,
	RadioGroup,
	RadioButton,
	Card,
	DatePicker,
	Link,
	Loading,
	Tag,
	Drawer,
	Progress,
	Steps,
	Step,
	Notification,
	Timeline,
	TimelineItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(InputNumber)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Radio)
Vue.use(Checkbox)
Vue.use(Rate)
Vue.use(Pagination)
Vue.use(CheckboxButton)
Vue.use(Cascader)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Select)
Vue.use(Option)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Submenu)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Card)
Vue.use(DatePicker)
Vue.use(Link)
Vue.use(Loading)
Vue.use(Tag)
Vue.use(Drawer)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification
Vue.prototype.$confirm = MessageBox

Vue.prototype.$confirmm = MessageBox.confirm
